import { Box, IconButton, useMediaQuery } from '@mui/material';

import { useLoadTheme } from '../../../../../config/loadThemeFromJson';

type Config = {
  nome: string;
  logo: string;
};

export function HeaderEscolaLegislativoLogo() {
  const theme = useLoadTheme();
  const isMobile = useMediaQuery(theme.breakpoints?.down('sm'));
  const logo = theme.custom?.logoEscolaLegislativo || '/images/logo_portal_transparencia.png';

  const nome = theme.custom?.nome || 'Nome Padrão';
  //const linkPortalTransparencia = theme.custom?.linkPortalTransparencia || 'https://portaldatransparencia.gov.br';
  //const logoPortalTransparencia = theme.custom?.logoPortalTransparencia || '/images/logo_portal_transparencia.png';

  return (
    <Box
      sx={{
        width: '100%',
        //height: { xs: 90, sm: 250 },
        display: 'flex',
        flexDirection: { xs: 'column', sm: 'row' },
        justifyContent: 'space-between',
        alignItems: 'center',
        overflow: 'hidden'
        //px: theme.spacing(2),
        //py: theme.spacing(1),
        //backgroundColor: theme.palette.background.default,
        // backgroundColor: "#ff2",
      }}
    >
      {/* LOGO DA EMPRESA */}

    
        <>
          <Box
            sx={{
              flex: 1,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              overflow: 'hidden',
              //backgroundColor: '#fff000',
              height: '250px',
              maxHeight: {
                xs: '90px', // celulares
                sm: '100px', // tablets
                md: '250px', // desktops
                lg: '350px' // telas maiores
              }
            }}
          >
            <IconButton
              onClick={() => (window.location.href = '/')}
              title="Início"
              sx={{
                p: 0,
                width: '100%',
                height: '100%'
              }}
            >
              <Box
                component="img"
                src={logo}
                alt={nome}
                sx={{
                  width: '100%', // ocupa toda largura
                  height: '100%', // ocupa toda altura
                  objectFit: 'contain' // cobre o Box sem distorcer
                }}
              />
            </IconButton>
          </Box>
        </>
   
    </Box>
  );
}
